import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const getWeeklySummaryCoachingStatus = gql`
  query WeeklySummaryCoachingStatus($userID: String!) {
    weeklySummaryCoachingStatus(userID: $userID) {
      lastCoachedDate
      lastCoachingStatus
      userID
    }
  }
`;

export const getAssociateInsightsQuery = gql`
  query GetAssociateInsights(
    $associates: [String!]!
    $associatesAliases: [String!]!
    $timeOption: TimeOption
    $timestamp: String
    $tmID: String!
  ) {
    getAssociateInsights(
      associates: $associates
      associatesAliases: $associatesAliases
      timeOption: $timeOption
      timestamp: $timestamp
      tmID: $tmID
    ) {
      associate
      bottomQuartileMetrics {
        label
        metricName
      }
      kudos {
        category
        contacts {
          contact
          contactStatus
        }
      }
      opportunities {
        category
        contacts {
          contact
          contactStatus
        }
      }
    }
  }
`;

export const getTeamLighthouseMetrics = gql`
  query GetTeamLighthouseMetrics(
    $channel: String!
    $isTM: [Boolean!]!
    $marketplace: String
    $segment: String!
    $skill: String!
    $syncMetrics: Boolean
    $team: [String!]!
    $timeOption: TimeOption!
    $timestamp: String!
    $userID: String!
    $vertical: String!
  ) {
    getTeamLighthouseMetrics(
      channel: $channel
      isTM: $isTM
      marketplace: $marketplace
      segment: $segment
      skill: $skill
      syncMetrics: $syncMetrics
      team: $team
      timeOption: $timeOption
      timestamp: $timestamp
      userID: $userID
      vertical: $vertical
    ) {
      userID
      metricTypes
      latestMetricPublishDate
      RAP {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          hmdYesAdjustedCount {
            datapoint
            networkAverage
          }
          prr {
            datapoint
            networkAverage
          }
          rapRepeatCount {
            datapoint
            networkAverage
          }
          hmdOfferRate {
            datapoint
            networkAverage
          }
          hmdResponseRate {
            datapoint
            networkAverage
          }
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
          fcr {
            datapoint
            networkAverage
          }
          nonOrderTaggingRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandability {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
          empathy {
            datapoint
            networkAverage
          }
          courtesy {
            datapoint
            networkAverage
          }
          helpfulness {
            datapoint
            networkAverage
          }
          efficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeUnderstandability {
            datapoint
            networkAverage
          }
          negativeKnowledgeable {
            datapoint
            networkAverage
          }
          negativeEmpathy {
            datapoint
            networkAverage
          }
          negativeCourtesy {
            datapoint
            networkAverage
          }
          negativeHelpfulness {
            datapoint
            networkAverage
          }
          negativeEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG_ONEBOX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeOneboxUnderstandability {
            datapoint
            networkAverage
          }
          negativeOneboxKnowledgeable {
            datapoint
            networkAverage
          }
          negativeOneboxEmpathy {
            datapoint
            networkAverage
          }
          negativeOneboxCourtesy {
            datapoint
            networkAverage
          }
          negativeOneboxHelpfulness {
            datapoint
            networkAverage
          }
          negativeOneboxEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      TR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          transferredContacts {
            datapoint
            networkAverage
          }
          muParkedRate {
            datapoint
            networkAverage
          }
          handledContacts {
            datapoint
            networkAverage
          }
          boomerangContactCount {
            datapoint
            networkAverage
          }
          consults {
            datapoint
            networkAverage
          }
          resolvedContacts {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
          resolveRate {
            datapoint
            networkAverage
          }
          lockToResolve {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      ACHT {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          acwTime {
            datapoint
            networkAverage
          }
          holdTime {
            datapoint
            networkAverage
          }
          ttcForMessageUs {
            datapoint
            networkAverage
          }
          acwTimeInbound {
            datapoint
            networkAverage
          }
          acwTimeOutbound {
            datapoint
            networkAverage
          }
          highSilenceRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DART {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dartUsedCount {
            datapoint
            networkAverage
          }
          totalHandledContact {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          giftCardsIssuedCount {
            datapoint
            networkAverage
          }
          oowExceptions {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DSR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dsrDenominator {
            datapoint
            networkAverage
          }
          dsrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      SDR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          sdrDenominator {
            datapoint
            networkAverage
          }
          sdrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONSULT_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          consults {
            datapoint
            networkAverage
          }
          phoneHandledContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      POLICY_ADHERENCE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          concessionGivenRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRNC {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityNoConcession {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRCI {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityConcessionIssued {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          ccxOverallService {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_CONCESSION_ISSUED {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_NO_CONCESSION {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONCESSION_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          promoteGCIssuedCount {
            datapoint
            networkAverage
          }
          oopExceptions {
            datapoint
            networkAverage
          }
          concessionIssuedPerContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_OFFER_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHandledContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_RESPONSE_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          offerCount {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      QCS {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      FCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
    }
  }
`;

export const getCustomTeamLighthouseMetrics = gql`
  query GetCustomTeamLighthouseMetrics(
    $channel: String!
    $endTimestamp: String!
    $isTM: [Boolean!]!
    $marketplace: String
    $segment: String!
    $skill: String!
    $startTimestamp: String!
    $syncMetrics: Boolean
    $team: [String!]!
    $userID: String!
    $vertical: String!
  ) {
    getCustomTeamLighthouseMetrics(
      channel: $channel
      endTimestamp: $endTimestamp
      isTM: $isTM
      marketplace: $marketplace
      segment: $segment
      skill: $skill
      startTimestamp: $startTimestamp
      syncMetrics: $syncMetrics
      team: $team
      userID: $userID
      vertical: $vertical
    ) {
      userID
      metricTypes
      latestMetricPublishDate
      RAP {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          hmdYesAdjustedCount {
            datapoint
            networkAverage
          }
          prr {
            datapoint
            networkAverage
          }
          rapRepeatCount {
            datapoint
            networkAverage
          }
          hmdOfferRate {
            datapoint
            networkAverage
          }
          hmdResponseRate {
            datapoint
            networkAverage
          }
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
          fcr {
            datapoint
            networkAverage
          }
          nonOrderTaggingRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandability {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
          empathy {
            datapoint
            networkAverage
          }
          courtesy {
            datapoint
            networkAverage
          }
          helpfulness {
            datapoint
            networkAverage
          }
          efficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeUnderstandability {
            datapoint
            networkAverage
          }
          negativeKnowledgeable {
            datapoint
            networkAverage
          }
          negativeEmpathy {
            datapoint
            networkAverage
          }
          negativeCourtesy {
            datapoint
            networkAverage
          }
          negativeHelpfulness {
            datapoint
            networkAverage
          }
          negativeEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG_ONEBOX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeOneboxUnderstandability {
            datapoint
            networkAverage
          }
          negativeOneboxKnowledgeable {
            datapoint
            networkAverage
          }
          negativeOneboxEmpathy {
            datapoint
            networkAverage
          }
          negativeOneboxCourtesy {
            datapoint
            networkAverage
          }
          negativeOneboxHelpfulness {
            datapoint
            networkAverage
          }
          negativeOneboxEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      TR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          transferredContacts {
            datapoint
            networkAverage
          }
          muParkedRate {
            datapoint
            networkAverage
          }
          handledContacts {
            datapoint
            networkAverage
          }
          boomerangContactCount {
            datapoint
            networkAverage
          }
          consults {
            datapoint
            networkAverage
          }
          resolvedContacts {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
          resolveRate {
            datapoint
            networkAverage
          }
          lockToResolve {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      ACHT {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          acwTime {
            datapoint
            networkAverage
          }
          holdTime {
            datapoint
            networkAverage
          }
          ttcForMessageUs {
            datapoint
            networkAverage
          }
          acwTimeInbound {
            datapoint
            networkAverage
          }
          acwTimeOutbound {
            datapoint
            networkAverage
          }
          highSilenceRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DART {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dartUsedCount {
            datapoint
            networkAverage
          }
          totalHandledContact {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          giftCardsIssuedCount {
            datapoint
            networkAverage
          }
          oowExceptions {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DSR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dsrDenominator {
            datapoint
            networkAverage
          }
          dsrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      SDR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          sdrDenominator {
            datapoint
            networkAverage
          }
          sdrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONSULT_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          consults {
            datapoint
            networkAverage
          }
          phoneHandledContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      POLICY_ADHERENCE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          concessionGivenRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRNC {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityNoConcession {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRCI {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityConcessionIssued {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          ccxOverallService {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_CONCESSION_ISSUED {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_NO_CONCESSION {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONCESSION_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          promoteGCIssuedCount {
            datapoint
            networkAverage
          }
          oopExceptions {
            datapoint
            networkAverage
          }
          concessionIssuedPerContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_OFFER_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHandledContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_RESPONSE_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          offerCount {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      QCS {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      FCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
    }
  }
`;

export const getCustomFilterOptions = gql`
  query GetCustomFilterOptions(
    $endTimestamp: String!
    $isTM: Boolean!
    $startTimestamp: String!
    $syncMetrics: Boolean
    $team: [String!]!
    $teamMemberIsTM: [Boolean!]!
    $userID: String!
    $isHistorical: Boolean
  ) {
    getCustomFilterOptions(
      endTimestamp: $endTimestamp
      isTM: $isTM
      startTimestamp: $startTimestamp
      syncMetrics: $syncMetrics
      team: $team
      teamMemberIsTM: $teamMemberIsTM
      userID: $userID
      isHistorical: $isHistorical
    ) {
      channels
      marketplaces
      segments
      skills
      verticals
    }
  }
`;

export const getCustomLighthouseMetrics = gql`
  query GetCustomLighthouseMetrics(
    $userID: String!
    $isTM: Boolean!
    $directReports: [String!]!
    $vertical: String!
    $channel: String!
    $skill: String!
    $segment: String!
    $marketplace: String
    $startTimestamp: String!
    $endTimestamp: String!
    $metrics: [LighthouseMetricOption!]!
    $syncMetrics: Boolean
  ) {
    getCustomLighthouseMetrics(
      userID: $userID
      isTM: $isTM
      directReports: $directReports
      vertical: $vertical
      channel: $channel
      skill: $skill
      segment: $segment
      marketplace: $marketplace
      startTimestamp: $startTimestamp
      endTimestamp: $endTimestamp
      metrics: $metrics
      syncMetrics: $syncMetrics
    ) {
      userID
      metricTypes
      latestMetricPublishDate
      RAP {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          hmdYesAdjustedCount {
            datapoint
            networkAverage
          }
          prr {
            datapoint
            networkAverage
          }
          rapRepeatCount {
            datapoint
            networkAverage
          }
          hmdOfferRate {
            datapoint
            networkAverage
          }
          hmdResponseRate {
            datapoint
            networkAverage
          }
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
          fcr {
            datapoint
            networkAverage
          }
          nonOrderTaggingRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandability {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
          empathy {
            datapoint
            networkAverage
          }
          courtesy {
            datapoint
            networkAverage
          }
          helpfulness {
            datapoint
            networkAverage
          }
          efficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeUnderstandability {
            datapoint
            networkAverage
          }
          negativeKnowledgeable {
            datapoint
            networkAverage
          }
          negativeEmpathy {
            datapoint
            networkAverage
          }
          negativeCourtesy {
            datapoint
            networkAverage
          }
          negativeHelpfulness {
            datapoint
            networkAverage
          }
          negativeEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG_ONEBOX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeOneboxUnderstandability {
            datapoint
            networkAverage
          }
          negativeOneboxKnowledgeable {
            datapoint
            networkAverage
          }
          negativeOneboxEmpathy {
            datapoint
            networkAverage
          }
          negativeOneboxCourtesy {
            datapoint
            networkAverage
          }
          negativeOneboxHelpfulness {
            datapoint
            networkAverage
          }
          negativeOneboxEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      TR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          transferredContacts {
            datapoint
            networkAverage
          }
          muParkedRate {
            datapoint
            networkAverage
          }
          handledContacts {
            datapoint
            networkAverage
          }
          boomerangContactCount {
            datapoint
            networkAverage
          }
          consults {
            datapoint
            networkAverage
          }
          resolvedContacts {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
          resolveRate {
            datapoint
            networkAverage
          }
          lockToResolve {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      ACHT {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          acwTime {
            datapoint
            networkAverage
          }
          holdTime {
            datapoint
            networkAverage
          }
          ttcForMessageUs {
            datapoint
            networkAverage
          }
          acwTimeInbound {
            datapoint
            networkAverage
          }
          acwTimeOutbound {
            datapoint
            networkAverage
          }
          highSilenceRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DART {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dartUsedCount {
            datapoint
            networkAverage
          }
          totalHandledContact {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          giftCardsIssuedCount {
            datapoint
            networkAverage
          }
          oowExceptions {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DSR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dsrDenominator {
            datapoint
            networkAverage
          }
          dsrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      SDR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          sdrDenominator {
            datapoint
            networkAverage
          }
          sdrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONSULT_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          consults {
            datapoint
            networkAverage
          }
          phoneHandledContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      POLICY_ADHERENCE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          concessionGivenRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRNC {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityNoConcession {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRCI {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityConcessionIssued {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          ccxOverallService {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_CONCESSION_ISSUED {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_NO_CONCESSION {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONCESSION_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          promoteGCIssuedCount {
            datapoint
            networkAverage
          }
          oopExceptions {
            datapoint
            networkAverage
          }
          concessionIssuedPerContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_OFFER_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHandledContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_RESPONSE_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          offerCount {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      QCS {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      FCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
    }
  }
`;
